<template>
    <div v-if="meetingDocuments.length" class="meeting-documents mb-xxl">
        <h4 class="h4 mb-xl">Meeting Documents</h4>
        <meeting-item
            v-for="item in meetingDocuments"
            :key="item.id"
            :title="item.title"
            :documents="item.documents"
            :links="item.links"
        />
    </div>
</template>

<script>
import MeetingItem from '@/committees/MeetingItem';
export default {
    name: "MeetingDocuments",
    components: {
        MeetingItem,
    },
     props: {
        meetingDocuments: {
            type: Array,
            default() {
                return [] 
            },
            required: true,
        }
    },
    beforeMount() {
        this.meetingDocuments = this.meetingDocuments.sort((a, b) => b.timestamp - a.timestamp);
    }
};
</script> 


<style lang="scss">
    .meeting-documents {
        border-bottom: 1px solid #dddddd;
    }
</style>